import React, { useEffect, useState } from "react";
import s from "../../styles/main.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPhone,
  faHandshake,
} from "@fortawesome/free-solid-svg-icons";

const CCvwcon = (props) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const teksten = props.teksten;
  const vwcon = teksten["contact-vwcon"];
  const [iframeSrc, setIframeSrc] = useState(vwcon["map-embed-url"]);
  const isEnglish = props.engels;

  function buildIframeFromSrc(jsonData) {
    const src = jsonData["map-embed-url"];
    if (!src) return null;

    // Optional modification logic
    const modifiedSrcNL = src
      .replace("!5e1!", "!5e0!")
      .replace("!4f13.1!", "!4f880!");

    const modifiedSrcEN = src
      .replace("!5e1!", "!5e0!")
      .replace("!4f13.1!", "!4f891!");

    return isEnglish ? modifiedSrcEN : modifiedSrcNL;
  }

  useEffect(() => {
    const newSrc = buildIframeFromSrc(vwcon);
    console.log(vwcon["map-embed-url"]);
    console.log(newSrc);
    setIframeSrc(newSrc);
  }, []);

  const iframeLoad = () => {
    setIframeLoaded(true);
    console.log("true");
  };

  return (
    <div className={s.contactBedrijf}>
      <div className={s.container}>
        <div className={s.heading}>
          <div className={s.title}>
            <div className={s.graphic}></div>
            <h2>{vwcon.titel}</h2>
          </div>
          <p>{vwcon.beschrijving}</p>
        </div>
        <div className={s.content}>
          <div className={s.info}>
            <div className={s.container}>
              <div className={s.item}>
                <div className={s.icon}>
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <div className={s.title}>{vwcon.blokken.deel1.titel}</div>
                <div className={s.contentSection}>
                  {vwcon.blokken.deel1.inhoud.map((item, i) => {
                    return (
                      <div>
                        {item}
                        <br />
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className={s.item}>
                <div className={s.icon}>
                  <FontAwesomeIcon icon={faPhone} />
                </div>
                <div className={s.title}>{vwcon.blokken.deel2.titel}</div>
                <div className={s.contentSection}>
                  {vwcon.blokken.deel2.inhoud.map((item, i) => {
                    return (
                      <div>
                        {item}
                        <br />
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className={s.item}>
                <div className={s.icon}>
                  <FontAwesomeIcon icon={faHandshake} />
                </div>
                <div className={s.title}>{vwcon.blokken.deel3.titel} </div>
                <div className={s.contentSection}>
                  {vwcon.blokken.deel3.inhoud.map((item, i) => {
                    return (
                      <div>
                        {item}
                        <br />
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* <div className={s.item}>
                  <div className={s.icon}>
                    <FontAwesomeIcon icon={faHandshake} />
                  </div>
                  <div className={s.title}>Woesik Consult België B.V. </div>
                  <div className={s.contentSection}>
                    Ondernemingsnr: 1234.567.890 <br />
                    BTW: BE 1234.567.890 <br />
                    Hoofdweg 2, 3842 GZ Harderwijk
                  </div>
                </div> */}
            </div>
          </div>
          {/* rid of view larger map on mobile or do sum with touch */}
          <div className={s.map}>
            {!iframeLoaded && (
              <div className={s.spinnerWrapper}>
                <div className={s.loadingText}>
                  <div className={s.spinner}></div>
                </div>
              </div>
            )}
            <iframe
              src={iframeSrc}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              onLoad={iframeLoad}
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CCvwcon;
